export default __webpack_public_path__ + "static/media/cont13.12b130ad.png";